import { render, staticRenderFns } from "./V2SendWishlistNotification.vue?vue&type=template&id=a54c8966&scoped=true&"
import script from "./V2SendWishlistNotification.vue?vue&type=script&lang=js&"
export * from "./V2SendWishlistNotification.vue?vue&type=script&lang=js&"
import style0 from "./V2SendWishlistNotification.vue?vue&type=style&index=0&id=a54c8966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54c8966",
  null
  
)

export default component.exports